<template>
    <div>
      <div v-bind:class="{ 'show': show}" class="toast">
        {{ message }}
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props:["message"],
    data() {
      return {
        show: true,
      };
    },
    methods: {
      showToast() {
        this.show = true;
        setTimeout(() => {
          this.show = false;
        }, 3000);
      }
    },
    created(){
        this.showToast()
    }
  };
  </script>
  
  <style scoped>
  .toast {
  visibility: hidden !important;
  min-width: 250px;
  margin: auto;
  background-color: #333 !important;
  color: #fff !important;
  text-align: center;
  border-radius: 8px;
  padding: 16px;
  position: fixed !important;
  z-index: 99999 !important;
  right: 30px !important;
  top: 30px !important;
  transform: translateY(-50%);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  font-size: 14px;
  font-weight: 500;
}

.toast.show {
  visibility: visible !important;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

@keyframes fadein {
  from {
    right: 0;
    opacity: 0;
  }
  to {
    right: 30px;
    opacity: 1;
  }
}

@keyframes fadeout {
  from {
    right: 30px;
    opacity: 1;
  }
  to {
    right: 0;
    opacity: 0;
  }
}
  </style>
  